<script setup lang="ts">
const t2 = useT2({
  'Body measurements': 'Kūno matmenys',
  Height: 'Ūgis',
  Bust: 'Krūtinė',
  Waist: 'Liemuo',
  Hip: 'Klubai',
  Email: 'El. paštas',
})

const props = defineProps<{
  title?: string
  subscribe?: boolean
  seller?: boolean
  measurements?: boolean
  social?: boolean
  productSeller?: boolean
  notitle?: boolean
  //
  profile: gen.SellerProfileFragment
  vertical?: boolean
}>()

const open = shallowRef(false)
const timer = useTimeout()
function openSet(val: boolean, ms: number) {
  if (open.value === val) return timer.clear()
  timer.set(() => (open.value = val), ms)
}

const ui2 = computed(() => {
  const { profile, seller } = props
  const sellerId = (seller && profile?.sellerId) || undefined
  return { sellerId, handle: !sellerId ? profile?.handle : undefined }
})

const cm = (i: number) => `${i}cm`
</script>

<template>
  <div class="_col _gap1" :class="[$style.cont, vertical ? 'vertical' : '']" v-bind="$attrs">
    <h4 v-if="title">{{ title }}</h4>
    <div class="_hidden" :class="[vertical ? '_col _gap1' : '_row _ctrY']">
      <BaseImage :img="profile?.image" sizes="120px" ratio="square" :alt2="SEO_NAME" no-color :class="$style.img" lazy />
      <div>
        <span v-if="!notitle && profile?.title" class="_c1 _fs08">{{ profile?.title }}</span>
        <div
          v-if="!notitle"
          class="_fw-xl _ls-xs _align-start _pt04 _flex _gap08 _ws_nowrap"
          :class="productSeller ? '_pt08 _row _ctrY' : '_col'"
          @mouseenter="openSet(true, 300)"
          @mouseleave="openSet(false, 400)"
        >
          <span>{{ profile?.publicName }}</span>
        </div>
      </div>
      <SubscriptionSellerNewsletter v-if="subscribe && ui2.sellerId" :seller-id="ui2.sellerId" />
    </div>

    <div class="_col">
      <UiLine :label="ts('Tel')" :value="profile.tel" />
      <UiLine :label="t2('Email')" :value="profile.email" />
      <LazyIdleSellerSocial v-if="profile?.contacts && social" hydrate-on-idle :contacts="profile?.contacts" />

      <template v-if="measurements">
        <h3>{{ t2('Body measurements') }}</h3>
        <UiLine :label="t2('Height')" :value="profile.modelHeight" :ui="(i) => cm(i)" />
        <UiLine :label="t2('Bust')" :value="profile.modelBust" :ui="(i) => cm(i)" />
        <UiLine :label="t2('Waist')" :value="profile.modelWaist" :ui="(i) => cm(i)" />
        <UiLine :label="t2('Hip')" :value="profile.modelHip" :ui="(i) => cm(i)" />
      </template>
    </div>

    <!-- <UiPreview4
    v-if="ui2.sellerId || ui2.handle"
    :elem="() => elem"
    :model-value="open"
    :dropdown="{ widthInnter: true }"
    @update:model-value="() => openSet(false, 0)"
    @mouseenter="openSet(true, 0)"
    @mouseleave="openSet(false, 400)"
  >
    <LinkPreviewUi
      v-if="ui2.sellerId"
      :open="open"
      type="Seller"
      :to="undefined"
      :get="ui2.sellerId"
    />
    :to="profile.handle ? myLink('@seller', { seller: profile.handle }) : undefined"

    <LinkPreviewUi
      v-else-if="ui2.handle"
      :open="open"
      type="Profile"
      :to="profile.handle ? myLink('i-handle', { handle: profile.handle }) : undefined"
      :get="profile?.handle"
    />
  </UiPreview4> -->
  </div>
</template>

<style module>
.cont {
  --img: 46px;
  composes: global(_flex);
  composes: global(m_gap2);
}
.cont:global(.vertical) {
  --img: 100px;
}
.img {
  composes: global(_br99);
  composes: global(_mr1);
  composes: global(_b5);
  composes: global(_block);
  composes: global(_bg0);
  composes: global(_a1);

  flex: 0 1 var(--img);
  height: var(--img);
  width: var(--img);
}
</style>
